module.exports = __webpack_public_path__ + "static/swiss-80470ecfbf90aeb4de83cd0eca9cedf0.png";